module.exports = __webpack_public_path__ + "img/yl_03.5912c444.png";